var render = function render(){
  var _vm$dataProject;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("SHIPMENT PLANNING")])])];
      },
      proxy: true
    }])
  }, [_c('b-modal', {
    attrs: {
      "title": "Filter Data",
      "ok-title": "Filter",
      "centered": ""
    },
    on: {
      "ok": _vm.onFilter
    },
    model: {
      value: _vm.modal.filter,
      callback: function callback($$v) {
        _vm.$set(_vm.modal, "filter", $$v);
      },
      expression: "modal.filter"
    }
  }, [_c('b-row', {}, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Cargo Type",
      "label-for": "cargo",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": "",
      "options": _vm.optionsCargoType
    },
    model: {
      value: _vm.params.cargo_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "cargo_type_id", $$v);
      },
      expression: "params.cargo_type_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("All")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Contract Type",
      "label-for": "cargo",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.params.contract_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "contract_type_id", $$v);
      },
      expression: "params.contract_type_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("All")]), _vm._l(_vm.optionsContractType, function (option, index) {
    return _c('b-form-select-option', {
      key: index,
      attrs: {
        "value": option.id
      }
    }, [_vm._v(" " + _vm._s(option.name) + " ")]);
  })], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Stage Status",
      "label-for": "stage_id",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "plain": "",
      "options": _vm.optionsStage
    },
    model: {
      value: _vm.params.stage_id,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "stage_id", $$v);
      },
      expression: "params.stage_id"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": null
    }
  }, [_vm._v("All")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Ownership",
      "label-for": "fleet_ownership",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2",
    attrs: {
      "plain": ""
    },
    model: {
      value: _vm.params.fleet_ownership,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "fleet_ownership", $$v);
      },
      expression: "params.fleet_ownership"
    }
  }, [_c('b-form-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _c('b-form-select-option', {
    attrs: {
      "value": "own-ship"
    }
  }, [_vm._v(" Own Ship ")]), _c('b-form-select-option', {
    attrs: {
      "value": "chartered"
    }
  }, [_vm._v(" Chartered ")])], 1)], 1)], 1), _vm.params.fleet_ownership ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-3",
    attrs: {
      "label": "Vehicle",
      "label-for": "vehicle_id",
      "label-cols-sm": "4",
      "label-cols-lg": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "text",
      "name": "vehicle_id",
      "options": _vm.optionsFleets,
      "reduce": function reduce(optionsFleets) {
        return optionsFleets.value;
      },
      "placeholder": "Select Fleet"
    },
    model: {
      value: _vm.params.vehicle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.params, "vehicle_id", $$v);
      },
      expression: "params.vehicle_id"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('b-row', {
    staticClass: "my-3 px-4 d-flex justify-content-end"
  }, [_c('b-col', {
    staticClass: "d-flex",
    attrs: {
      "md": "6"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "type": "date",
      "range": "",
      "placeholder": "Select date range",
      "format": "DD/MM/YYYY"
    },
    on: {
      "input": _vm.onFilter
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c('b-button', {
    staticClass: "d-flex align-items-center ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.toggleModalFilter
    }
  }, [_c('i', {
    staticClass: "fas fa-sliders"
  }), _c('p', {
    staticClass: "text-truncate m-0"
  }, [_vm._v("Filter Data")])]), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Refresh Data',
      expression: "'Refresh Data'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "d-flex align-items-center ml-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.onFilter
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  })])], 1), _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "6"
    }
  }, [_c('strong', {
    staticStyle: {
      "align-self": "center"
    }
  }, [_vm._v("Display :  ")]), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    class: {
      active: _vm.view_style === 'list'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.view_style = 'list';
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-list"
  }), _vm._v(" List ")]), _c('button', {
    staticClass: "btn btn-outline-primary",
    class: {
      active: _vm.view_style === 'kanban'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.view_style = 'kanban';
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-th-large"
  }), _vm._v(" Kanban ")])]), _c('div', {
    staticClass: "mx-2",
    staticStyle: {
      "border-left": "1px solid"
    }
  }), [_c('b-dropdown', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.top",
      value: 'Export Data',
      expression: "'Export Data'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "mr-1",
    attrs: {
      "boundary": "window",
      "dropdown-append-to-body": "",
      "variant": "link iq-bg-primary",
      "toggle-class": "text-decoration-none",
      "no-caret": ""
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "dropdown-toggle p-0",
          attrs: {
            "id": "dropdownMenuButton5",
            "data-toggle": "dropdown"
          }
        }, [_c('i', {
          staticClass: "fa fa-download mr-1"
        }), _vm._v(" Export ")])];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#",
      "variant": "dark"
    },
    on: {
      "click": _vm.onExportShipmentPlanning
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel mr-2"
  }), _vm._v(" Export Excel ")]), _c('b-dropdown-item', {
    attrs: {
      "href": "#",
      "variant": "dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf mr-2"
  }), _vm._v(" Export PDF ")])], 1), _vm.addPermission ? _c('b-button', {
    staticClass: "float-right mr-1",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.openSlideFormAddPlan('ADD', null);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("   Add Plan ")]) : _vm._e()]], 2)], 1), _vm.view_style === 'list' ? [_c('b-row', {
    staticClass: "m-2"
  }, [!_vm.loading ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex overflow-auto",
    staticStyle: {
      "max-height": "500px"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', {
    staticClass: "sticky-header"
  }, [_c('th', {
    staticClass: "text-truncate column-1"
  }, [_vm._v("Company")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Customers")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Subject")]), _c('th', {
    staticClass: "text-truncate",
    staticStyle: {
      "width": "150px"
    }
  }, [_vm._v(" Periode Project ")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Type")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Total Shipment")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Contract Type")]), _c('th', {
    staticClass: "text-truncate text-center"
  }, [_vm._v("SPAL")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Cargo Type")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Total Volume")]), _c('th', {
    staticClass: "text-truncate"
  }, [_vm._v("Created By")]), _c('th', {
    staticClass: "text-truncate text-center"
  }, [_vm._v("Priority")]), _c('th', {
    staticClass: "text-truncate text-center"
  }, [_vm._v("Status")]), _c('th', {
    staticClass: "text-truncate column-stage text-center"
  }, [_vm._v(" Stage ")]), _c('th', {
    staticClass: "text-center column-action"
  }, [_vm._v("Action")])])]), _vm.listShipmentPlanningTable.data.length > 0 ? _c('tbody', _vm._l(_vm.listShipmentPlanningTable.data, function (state, index) {
    var _state$company, _state$customer, _state$contract_type, _state$cargo_type, _state$spal_process, _state$cargo_type2, _state$volume, _state$cargo_type3, _state$cargo_type3$un, _state$cargo_type3$un2, _state$cargo_type3$un3, _state$project_log, _state$project_log$, _vm$optionPriority$fi, _state$project_stage, _state$project_stage2, _state$contract_type2;
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-truncate column-1 bg-white"
    }, [state !== null && state !== void 0 && state.company ? _c('span', [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$company = state.company) === null || _state$company === void 0 ? void 0 : _state$company.company) + " ")]) : _vm._e()]), _c('td', {
      staticClass: "text-truncate bg-white"
    }, [state !== null && state !== void 0 && state.customer ? _c('span', [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : (_state$customer = state.customer) === null || _state$customer === void 0 ? void 0 : _state$customer.account_name) || '-') + " ")]) : _vm._e()]), _c('td', {
      staticClass: "text-truncate bg-white"
    }, [_c('span', [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : state.subject) || '-') + " ")])]), _c('td', {
      staticClass: "text-center bg-white"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(_vm.moment(state === null || state === void 0 ? void 0 : state.periode_start).format('DD/MM/YYYY')) + " ")]), _c('span', {
      staticClass: "mx-2"
    }, [_vm._v("-")]), _c('div', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(_vm.moment(state === null || state === void 0 ? void 0 : state.periode_end).format('DD/MM/YYYY')) + " ")])])]), _c('th', {
      staticClass: "bg-white text-black"
    }, [_c('b-badge', {
      staticClass: "border border-primary text-primary text-uppercase",
      attrs: {
        "variant": "none"
      }
    }, [_vm._v(" " + _vm._s((state === null || state === void 0 ? void 0 : state.project_type) === 'existing' ? 'EXISTING' : 'NEW PROJECT') + " ")])], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : state.shipment) + " Shipment ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_c('div', {
      staticClass: "d-flex flex-column align-items-center justify-content-center"
    }, [_c('span', [_vm._v(_vm._s(state === null || state === void 0 ? void 0 : (_state$contract_type = state.contract_type) === null || _state$contract_type === void 0 ? void 0 : _state$contract_type.name))])])]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-form-checkbox', {
      attrs: {
        "checked": state !== null && state !== void 0 && (_state$cargo_type = state.cargo_type) !== null && _state$cargo_type !== void 0 && _state$cargo_type.is_spal ? (state === null || state === void 0 ? void 0 : (_state$spal_process = state.spal_process) === null || _state$spal_process === void 0 ? void 0 : _state$spal_process.length) > 0 : false,
        "switch": "",
        "size": "sm",
        "disabled": ""
      }
    })], 1), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type2 = state.cargo_type) === null || _state$cargo_type2 === void 0 ? void 0 : _state$cargo_type2.name) + " ")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.volume ? state === null || state === void 0 ? void 0 : (_state$volume = state.volume) === null || _state$volume === void 0 ? void 0 : _state$volume.toLocaleString() : '0') + " " + _vm._s(state === null || state === void 0 ? void 0 : (_state$cargo_type3 = state.cargo_type) === null || _state$cargo_type3 === void 0 ? void 0 : (_state$cargo_type3$un = _state$cargo_type3.unit) === null || _state$cargo_type3$un === void 0 ? void 0 : (_state$cargo_type3$un2 = _state$cargo_type3$un.child) === null || _state$cargo_type3$un2 === void 0 ? void 0 : (_state$cargo_type3$un3 = _state$cargo_type3$un2.find(function (el) {
      return el.name === state.unit;
    })) === null || _state$cargo_type3$un3 === void 0 ? void 0 : _state$cargo_type3$un3.alias) + " ")]), _c('td', {
      staticClass: "text-primary text-truncate"
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$project_log = state.project_log) === null || _state$project_log === void 0 ? void 0 : (_state$project_log$ = _state$project_log[0]) === null || _state$project_log$ === void 0 ? void 0 : _state$project_log$.name) + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(" " + _vm._s(state !== null && state !== void 0 && state.prioritize ? (_vm$optionPriority$fi = _vm.optionPriority.find(function (el) {
      return el.value === Number(state === null || state === void 0 ? void 0 : state.prioritize);
    })) === null || _vm$optionPriority$fi === void 0 ? void 0 : _vm$optionPriority$fi.text : '-') + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('i', {
      staticClass: "fas fa-circle text-warning"
    }), _vm._v(" Requested ")])]), _c('td', {
      staticClass: "text-center bg-white text-black column-stage"
    }, [_c('b-button', {
      staticClass: "text-decoration-none",
      attrs: {
        "id": "stage-popover-".concat(index),
        "variant": "primary",
        "size": "sm"
      }
    }, [_vm._v(" " + _vm._s(state === null || state === void 0 ? void 0 : (_state$project_stage = state.project_stage) === null || _state$project_stage === void 0 ? void 0 : _state$project_stage.title) + " "), _c('i', {
      staticClass: "fa fa-caret-down ml-1"
    })]), _c('b-popover', {
      attrs: {
        "target": "stage-popover-".concat(index),
        "triggers": "focus",
        "placement": "bottom",
        "custom-class": "p-0 border-0 shadow-sm"
      }
    }, [_c('div', {
      staticClass: "list-group list-group-flush text-left"
    }, _vm._l(_vm.listProjectStage, function (obj, objIndex) {
      return _c('button', {
        key: objIndex,
        staticClass: "list-group-item list-group-item-action",
        class: {
          active: (state === null || state === void 0 ? void 0 : state.detail_project_stage_id) === obj.id
        },
        on: {
          "click": function click($event) {
            return _vm.onChangeStatusStage(index, state === null || state === void 0 ? void 0 : state.id, obj.id, state, obj);
          }
        }
      }, [_vm._v(" " + _vm._s(obj === null || obj === void 0 ? void 0 : obj.title) + " ")]);
    }), 0)])], 1), _vm.updatePermission || _vm.deletePermission ? _c('td', {
      staticClass: "text-center bg-white text-black column-action"
    }, [_c('b-button', {
      attrs: {
        "id": "action-popover-".concat(index),
        "variant": "outline-primary",
        "size": "sm"
      }
    }, [_vm._v(" Action "), _c('i', {
      staticClass: "fa fa-caret-down ml-1"
    })]), _c('b-popover', {
      attrs: {
        "target": "action-popover-".concat(index),
        "triggers": "focus",
        "placement": "bottom",
        "custom-class": "p-0 border-0 shadow-sm"
      }
    }, [_c('div', {
      staticClass: "list-group list-group-flush text-left"
    }, [_c('button', {
      staticClass: "list-group-item list-group-item-action",
      on: {
        "click": function click($event) {
          return _vm.openSlideFormAddPlan('PREVIEW', state === null || state === void 0 ? void 0 : state.id);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye mr-2 text-primary"
    }), _vm._v(" Detail Shipment ")]), state !== null && state !== void 0 && state.is_pfa ? _c('button', {
      staticClass: "list-group-item list-group-item-action",
      on: {
        "click": function click($event) {
          return _vm.openPfaSlide(state);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle mr-2 text-warning"
    }), _vm._v(" Pre Fixture Analysis ")]) : _vm._e(), state !== null && state !== void 0 && (_state$project_stage2 = state.project_stage) !== null && _state$project_stage2 !== void 0 && _state$project_stage2.spal_process && state !== null && state !== void 0 && (_state$contract_type2 = state.contract_type) !== null && _state$contract_type2 !== void 0 && _state$contract_type2.is_spal ? _c('button', {
      staticClass: "list-group-item list-group-item-action",
      on: {
        "click": function click($event) {
          return _vm.openSlideSpalProcess('ADD', state === null || state === void 0 ? void 0 : state.id);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle mr-2 text-success"
    }), _vm._v(" Spal Process ")]) : _vm._e(), _vm.canApprove(state) ? _c('button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.project-approval",
        modifiers: {
          "project-approval": true
        }
      }],
      staticClass: "list-group-item list-group-item-action",
      on: {
        "click": function click($event) {
          return _vm.handleOpenModalApproval(state === null || state === void 0 ? void 0 : state.id);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check mr-2 text-primary"
    }), _vm._v(" Approval ")]) : _vm._e(), _c('button', {
      staticClass: "list-group-item list-group-item-action text-danger",
      on: {
        "click": function click($event) {
          return _vm.onDeleteProjectContract(state);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash mr-2"
    }), _vm._v(" Delete ")])])])], 1) : _vm._e()]);
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center align-middle",
    attrs: {
      "colspan": "11"
    }
  }, [_c('strong', {
    staticClass: "text-muted"
  }, [_vm._v(" No Data Shipment Planning. ")])])])])])]), _vm.listShipmentPlanningTable.data.length > 0 ? _c('div', {
    staticClass: "mt-3 d-flex justify-content-between align-items-center"
  }, [_c('div', [_vm._v(" Total Rows: "), _c('span', {
    staticClass: "font-weight-bold text-black"
  }, [_vm._v(" " + _vm._s(_vm.listShipmentPlanningTable.meta.totalItem) + " ")])]), _c('b-pagination', {
    attrs: {
      "total-rows": _vm.listShipmentPlanningTable.meta.totalItem,
      "per-page": _vm.listShipmentPlanningTable.meta.perPage,
      "first-number": "",
      "align": "center"
    },
    on: {
      "change": _vm.getListShipmentPlanningTable
    },
    model: {
      value: _vm.listShipmentPlanningTable.meta.page,
      callback: function callback($$v) {
        _vm.$set(_vm.listShipmentPlanningTable.meta, "page", $$v);
      },
      expression: "listShipmentPlanningTable.meta.page"
    }
  })], 1) : _vm._e()]) : _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Loading...")])])], 1)] : _vm._e(), _vm.view_style === 'kanban' ? [_c('KanbanNew', {
    attrs: {
      "kanbanData": _vm.kanbanData,
      "canApprove": _vm.canApprove
    },
    on: {
      "openModalApproval": _vm.handleOpenModalApproval,
      "reorderStages": _vm.reorderStages,
      "openSlideFormAddPlan": _vm.openSlideFormAddPlan,
      "openPfaSlide": _vm.openPfaSlide,
      "openProjectFormSlide": _vm.openProjectFormSlide,
      "openSlideSpalProcess": _vm.openSlideSpalProcess,
      "onDeleteProjectContract": _vm.onDeleteProjectContract,
      "onCardMove": _vm.onCardMove,
      "refetch": _vm.onRefetchKanbanNew,
      "onDenied": _vm.onDenied,
      "onSpalProcess": _vm.onSpalProcess,
      "onRunningProcess": _vm.onRunningProcess,
      "onEndStage": _vm.onEndStage,
      "onRemoveStage": _vm.onRemoveList
    }
  })] : _vm._e(), _c('CustomSidebar', {
    attrs: {
      "title": ['PREVIEW', 'EDIT'].includes(_vm.action) ? 'DETAIL PLAN' : "ADD PLAN",
      "size": "100%"
    },
    model: {
      value: _vm.slideAddRakor,
      callback: function callback($$v) {
        _vm.slideAddRakor = $$v;
      },
      expression: "slideAddRakor"
    }
  }, [_vm.slideAddRakor ? [_c('FormAddPlanNew', {
    attrs: {
      "optionsCompanies": _vm.optionsCompanies,
      "optionsFleets": _vm.optionsFleets,
      "editId": _vm.editId,
      "isDetail": _vm.action === 'PREVIEW'
    },
    on: {
      "refresh-data": _vm.onFormSaved,
      "close": function close($event) {
        _vm.slideAddRakor = false;
      }
    }
  })] : _vm._e()], 2), _vm.slideAddPFA ? _c('b-sidebar', {
    attrs: {
      "id": "slideAddPFA",
      "title": "ADD PFA(PRE FIXTURE ANALYSIS)",
      "width": "100%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.slideAddPFA,
      callback: function callback($$v) {
        _vm.slideAddPFA = $$v;
      },
      expression: "slideAddPFA"
    }
  }, [[_vm.slideAddPFA ? _c('SlideFormPFA', {
    attrs: {
      "pfa-action": 'EDIT',
      "pfa-id": (_vm$dataProject = _vm.dataProject) === null || _vm$dataProject === void 0 ? void 0 : _vm$dataProject.id,
      "data-project": _vm.dataProject,
      "options-fleets": _vm.optionsFleets,
      "optionsCargoType": _vm.optionsCargoType
    },
    on: {
      "uploaded": function uploaded() {
        _vm.refreshDataTable();
        _vm.slideAddPFA = false;
      },
      "close": function close() {
        _vm.slideAddPFA = false;
      }
    }
  }) : _vm._e()]], 2) : _vm._e(), _vm.slideSpalProcess ? _c('b-sidebar', {
    attrs: {
      "id": "slideSpalProcess",
      "title": "SPAL Process",
      "width": "70%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.slideSpalProcess,
      callback: function callback($$v) {
        _vm.slideSpalProcess = $$v;
      },
      expression: "slideSpalProcess"
    }
  }, [[_c('SlideSpalProcess', {
    attrs: {
      "id": _vm.editId,
      "closeSlideSpalProcess": _vm.closeSlideSpalProcess,
      "refreshDataTableWithoutCloseModal": _vm.refreshDataTableWithoutCloseModal,
      "refreshDataTable": _vm.refreshDataTable,
      "action": 'ADD'
    }
  })]], 2) : _vm._e(), _vm.slideProjectForms ? _c('b-sidebar', {
    attrs: {
      "id": "slideProjectForms",
      "title": _vm.projectName + '/Collection of Forms',
      "width": "80%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.slideProjectForms,
      callback: function callback($$v) {
        _vm.slideProjectForms = $$v;
      },
      expression: "slideProjectForms"
    }
  }, [[_c('SlideProjectForms', {
    attrs: {
      "form-id": _vm.editId,
      "open-inspection-checklist-slide": _vm.openInspectionChecklistSlide
    }
  })]], 2) : _vm._e(), _vm.isPreviewInspectionChecklist ? _c('b-sidebar', {
    attrs: {
      "id": "isPreviewInspectionChecklist",
      "title": 'Preview Inspection Checklist',
      "width": "70%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.isPreviewInspectionChecklist,
      callback: function callback($$v) {
        _vm.isPreviewInspectionChecklist = $$v;
      },
      expression: "isPreviewInspectionChecklist"
    }
  }, [[_c('SlideInspectionChecklist', {
    attrs: {
      "is-preview-inspection-checklist": _vm.isPreviewInspectionChecklist,
      "inspection-checklist-data": _vm.inspectionChecklistData
    }
  })]], 2) : _vm._e(), _vm.isAddInspectionChecklist ? _c('b-sidebar', {
    attrs: {
      "id": "isAddInspectionChecklist",
      "title": 'Create Inspection Checklist',
      "width": "70%",
      "backdrop-variant": "dark",
      "bg-variant": "white",
      "right": "",
      "backdrop": "",
      "shadow": ""
    },
    model: {
      value: _vm.isAddInspectionChecklist,
      callback: function callback($$v) {
        _vm.isAddInspectionChecklist = $$v;
      },
      expression: "isAddInspectionChecklist"
    }
  }, [[_c('div', {
    staticClass: "p-3"
  }, [_c('SlideCreateInspectionChecklist', {
    attrs: {
      "inspection-checklist-data": _vm.inspectionChecklistData,
      "refresh-slide-forms": _vm.refreshSlideForms,
      "isAddInspectionChecklist": _vm.isAddInspectionChecklist
    }
  })], 1)]], 2) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "project-approval",
      "size": "md",
      "title": "APPROVAL",
      "cancel-title": "Close",
      "hide-footer": ""
    }
  }, [[_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2",
    attrs: {
      "rows": "3",
      "name": "remarks",
      "placeholder": "Remarks..."
    },
    model: {
      value: _vm.remarks,
      callback: function callback($$v) {
        _vm.remarks = $$v;
      },
      expression: "remarks"
    }
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "border d-flex w-100 my-4"
  })]), _vm.approval_loading ? _c('b-col', {
    attrs: {
      "lg": "12",
      "align": "center"
    }
  }, [_c('span', {
    staticClass: "spinner-border spinner-border-sm"
  })]) : _vm._e(), !_vm.approval_loading ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "warning",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.onSaveApproval('rejected');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban mr-2"
  }), _vm._v(" Reject ")])], 1) : _vm._e(), !_vm.approval_loading ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.onSaveApproval('approved');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check mr-2"
  }), _vm._v(" Approve ")])], 1) : _vm._e()], 1)]], 2), _c('CustomSidebar', {
    attrs: {
      "title": "New Running Shipment",
      "size": "50%",
      "noCloseOnBackdrop": "",
      "noCloseOnEsc": ""
    },
    model: {
      value: _vm.showSidebarRunning,
      callback: function callback($$v) {
        _vm.showSidebarRunning = $$v;
      },
      expression: "showSidebarRunning"
    }
  }, [_vm.showSidebarRunning ? _c('FormAddRunningShipment', {
    attrs: {
      "kanbanData": _vm.kanbanData,
      "selected-task": _vm.selectedTask
    },
    on: {
      "close": _vm.handleRunningClose,
      "refetch": function refetch($event) {
        return _vm.$emit('refetch');
      },
      "submit": _vm.submitFormAddRunningShipment
    }
  }) : _vm._e()], 1)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }